import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from 'classnames';
import useToast from './useToast';
import IconButton from '@widget/buttons/IconButton';
import Icon from '@icon/Icon';
const Toast = React.memo((props) => {
    // props
    let { type, title, content, icon, showCloseBtn, autoClose, onClose, closeAfter, instance, createdAt } = props;
    // toast remove method
    const { remove } = useToast();
    // Default icon mapping for toast types
    const defaultIconMap = {
        success: ['fas', 'check-circle'],
        error: ['fas', 'times-circle'],
        warning: ['fas', 'exclamation-triangle'],
        info: ['fas', 'info-circle'],
        custom: ['fas', 'bell']
    };
    // ref 
    const ToastRef = React.useRef(null);
    // on mount
    React.useEffect(() => {
        if (autoClose) {
            let _closeAfter = closeAfter;
            let _createdAt = createdAt;
            let now = new Date();
            let nowTime = now.getTime();
            if ((nowTime - _createdAt) >= _closeAfter) {
                handleRemove();
            }
            else {
                // cal timeout delay
                let delay = (_closeAfter - (nowTime - _createdAt));
                let timeout = setTimeout(() => {
                    handleRemove();
                }, delay);
                return () => { clearTimeout(timeout); };
            }
        }
    }, [instance, remove]);
    // handle remove
    const handleRemove = () => {
        ToastRef.current.classList.remove("uxpcore_toast--show");
        ToastRef.current.classList.add("uxpcore_toast--hide");
        setTimeout(() => {
            remove(instance);
            if (onClose)
                onClose();
        }, 300);
    };
    // return
    return (_jsxs("div", { className: classNames("uxpcore_toast", `uxpcore_toast--${type}`, "uxpcore_toast--show"), ref: ToastRef, children: [type == "custom" ?
                _jsx("div", { className: "uxpcore_toast__content", children: typeof content == "string" ? content : content() })
                :
                    _jsxs(_Fragment, { children: [_jsx("div", { className: "uxpcore_toast__icon", children: (() => {
                                    if (icon && typeof icon === 'function') {
                                        return icon();
                                    }
                                    const iconToRender = icon || defaultIconMap[type];
                                    return _jsx(Icon, { icon: iconToRender });
                                })() }), _jsxs("div", { className: "uxpcore_toast__content", children: [title &&
                                        _jsx("div", { className: "uxpcore_toast__title", children: typeof title == "string" ? title : title() }), _jsx("div", { className: "uxpcore_toast__body", children: typeof content == "string" ? content : content() })] })] }), showCloseBtn && (_jsx(IconButton, { type: "close", onClick: handleRemove, variant: "secondary", size: "small", className: "uxpcore_toast__close" }))] }));
});
export default Toast;
